import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({

	state: {
		languageCode: 'zh',
		current: 1,
	},

	mutations: {
		setLanguage(state,languageCode){
            state.languageCode = languageCode 
        },
		setCurrent(state,current){
            state.current = current 
        }
	}
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js